import React, { Fragment } from "react";
import { Button, Spinner } from "react-bootstrap";

export default ({
  isLoading,
  text,
  loadingText,
  className = "",
  disabled = false,
  ...props
}) =>
  <Button variant="dark" size="sm"
    disabled={disabled || isLoading}
    {...props}
  >
    {isLoading ? <div className="align-middle"><Spinner className="align-middle"
      as="span"
      animation="grow"
      size="sm"
      role="status"
      aria-hidden="true"
    />&nbsp;&nbsp;&nbsp;&nbsp;{loadingText}</div>: <span>{text}</span>}
  </Button>;
